'use es6';

import { EntityStatus, Networks } from './Constants';
export const NAME = 'name';
export const BUDGET = 'budget';
export const SCHEDULE = 'schedule';
export const MAX_BUDGET = 'maxBudget';
export const MIN_BUDGET = 'minBudget';
export const DAILY_BUDGET = 'dailyBudget';
export const TOTAL_BUDGET = 'totalBudget';
export const KEYWORD_TEXT = 'keywordText';
export const MATCH_TYPE = 'matchType';
export const CampaignManagementItemErrors = {
  END_DATE_REQUIRED: 'END_DATE_REQUIRED',
  END_DATE_MUST_BE_IN_FUTURE: 'END_DATE_MUST_BE_IN_FUTURE',
  TARGET_ROAS_REQUIRED: 'TARGET_ROAS_REQUIRED',
  TARGET_CPA_REQUIRED: 'TARGET_CPA_REQUIRED',
  TARGET_CPC_REQUIRED: 'TARGET_CPC_REQUIRED'
}; // Google is using 12/30/2037 as a default end time for "continuous" ads.
// If they ever switch to 64-bit time, we'll probably need to update this.
// Calculated using I18n.moment({ year: 2037, month: 11, day: 30 }).valueOf()

const GOOGLE_END_TIME = 2145762000000;
export const getRequestData = (network, entity, update) => Object.keys(update).reduce((priorChanges, type) => {
  const value = update[type];

  switch (type) {
    case BUDGET:
      {
        if (value.budgetId) {
          return Object.assign({}, priorChanges, {
            budget: Object.assign({}, value.getRequestData(), {
              budgetId: value.budgetId
            })
          });
        }

        return Object.assign({}, priorChanges, {
          budget: value.getRequestData()
        });
      }

    case DAILY_BUDGET:
      return Object.assign({}, priorChanges, {
        budget: value.getRequestData()
      });

    case MIN_BUDGET:
      return Object.assign({}, priorChanges, {
        minBudget: value.getRequestData()
      });

    case MAX_BUDGET:
    case TOTAL_BUDGET:
      return Object.assign({}, priorChanges, {
        maxBudget: value.getRequestData()
      });

    case SCHEDULE:
      {
        switch (network) {
          case Networks.FACEBOOK:
            {
              return Object.assign({}, priorChanges, {}, value.getChangedRequestData(entity.schedule));
            }

          case Networks.LINKEDIN:
            {
              return Object.assign({}, priorChanges, {}, value.getRequestData(), {}, entity.status === EntityStatus.COMPLETED ? {
                status: EntityStatus.ACTIVE,
                // LinkedIn demands the exact start time as originally passed.
                // We only allow editing the end date, so this won't overwrite anything
                // the user selected.
                startTimeMillis: entity.schedule.startTimeMillis
              } : {});
            }

          case Networks.ADWORDS:
            {
              const {
                startTimeMillis,
                endTimeMillis
              } = value.getChangedRequestData(entity.schedule);
              return Object.assign({}, priorChanges, {
                startTimeMillis,
                endTimeMillis: endTimeMillis === null ? GOOGLE_END_TIME : endTimeMillis
              });
            }

          default:
            {
              throw new Error(`Unsupported network: ${network}`);
            }
        }
      }

    case KEYWORD_TEXT:
      return {
        text: value
      };

    default:
      return Object.assign({}, priorChanges, {
        [type]: value
      });
  }
}, {});